import type { ActionTree, GetterTree, MutationTree } from 'vuex';
import { toCamelTransformator } from '@/components/utils/core/object';
import type { IProduct } from '@/types/common';
import type { ProductsState } from '~/types/store/products';
import type { RootState } from '~/types/store/index';

export const state = (): ProductsState => ({
  products: [],
  categories: [],
  loading: false,
});

export const actions: ActionTree<ProductsState, RootState> = {
  async fetchProducts({ commit }) {
    commit('updateState', { loading: true });
    const { products, categories } = await this.$api.$get(`/api/war_room/products.json`, {
      // @ts-ignore
      transformResponse: [...this.$api.defaults.transformResponse, toCamelTransformator],
    });

    commit('updateState', { products, categories, loading: false });
  },
};

export const getters: GetterTree<ProductsState, RootState> = {
  products(state): Array<IProduct> {
    return state.products;
  },
  currentProduct(state, _, rootState): IProduct | undefined {
    const id = Number(rootState.route.params.id || rootState.route.query.id);
    return state.products.find(p => p.id === id);
  },
};

export const mutations: MutationTree<ProductsState> = {
  updateState(state, newState) {
    Object.assign(state, newState);
  },
};
